import {
  Component,
  ElementRef,
  Input,
  OnInit,
  output,
  viewChild,
  inject,
} from '@angular/core';
import { fromEvent } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
} from 'rxjs/operators';
import { PlacePredictionService } from '../../servicios/place-prediction.service';

@Component({
  selector: 'app-autocomplete-direccion',
  templateUrl: './autocomplete-direccion.component.html',
  styleUrls: ['./autocomplete-direccion.component.scss'],
  standalone: false,
})
export class AutocompleteDireccionComponent implements OnInit {
  private placePredictionService = inject(PlacePredictionService);

  public loading = false;
  public direcciones: string[] = [];

  readonly inputDireccion = viewChild<ElementRef>('inputDireccion');

  @Input() direccion = '';
  readonly direccionChange = output<string>();

  public onDireccionChange(direccion: string): void {
    this.direccionChange.emit(direccion);
  }

  private listenDirChange(): void {
    fromEvent(this.inputDireccion()?.nativeElement, 'keyup')
      .pipe(
        map((e: any) => e.target.value),
        filter(() => !this.loading),
        debounceTime(500),
        distinctUntilChanged(),
      )
      .subscribe(async (text: string) => {
        this.direcciones =
          await this.placePredictionService.getPlacePredictions(this.direccion);
      });
  }

  ngOnInit(): void {
    this.listenDirChange();
  }
}
